/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_ToolsInputs */



/**
* | output |
* | --- |
* | "AI Tools" |
*
* @param {Ai_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_tools = /** @type {((inputs?: Ai_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Outils IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Tools")
	if (locale === "it") return /** @type {LocalizedString} */ ("Strumenti di intelligenza artificiale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инструменты искусственного интеллекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Herramientas de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("人工智能工具")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIツール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई उपकरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ferramentas de IA")
	return /** @type {LocalizedString} */ ("AI Tools")
});